import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario, actionsPeticiones} from '../../../../actions/action-creators'
import {
  gu_cu_ChangePage,
  gu_cu_HandleChange,
  gu_cu_creacionUsuarioFormAddError,
} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {DICCIONARIO} from '../../../../constants/Diccionario'
import {Tooltip} from '@mui/material'

// import {isNullOrEmpty} from '../../../../utils/strings.utils'

const CUStep11Usuario = () => {
  const [disabled, setDisabled] = useState(true)
  const {formUser, formError} = useSelector((state: State) => state.gestionUsuario.creacionUsuario)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)
  const peticiones = bindActionCreators(actionsPeticiones, dispatch)

  useEffect(() => {
    getUsername()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (formUser.username && formUser.email && !formError.username && !formError.email)
      setDisabled(false)
    else setDisabled(true)
  }, [formUser, formError])

  const getUsername = async () => {
    const username2 = await peticiones.obtenerUsernameAleatorio(
      formUser.first_name,
      formUser.last_name
    )
    dispatch(gu_cu_HandleChange({username2}))
  }

  const sugerencia = () => {
    dispatch(gu_cu_HandleChange({username: formUser.username2}))
    dispatch(gu_cu_creacionUsuarioFormAddError({username: ''}))
  }

  const submit = async (e: any) => {
    e.preventDefault();

    if (await actions.gu_cu_validacionesCreacionUsuarioSiguiente2()) return
    const bool: any = await peticiones.validarUsername(formUser.username)
    if (bool !== 'true') {
      dispatch(gu_cu_creacionUsuarioFormAddError({username: bool}))
      return
    }
    dispatch(gu_cu_ChangePage(1))
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    actions.gu_cu_FormHandleChange(e)
    actions.gu_cu_validacionesCreacionUsuarioOnBlur(e)
  }

  const cancelar = async () => dispatch(gu_cu_ChangePage(-1))

  return (
    <form className='card w-form w-100  mt-16' autoComplete='off' onSubmit={submit}>
      <div className='card-basic w-100'>
        <div className='mb-16'>
          <h3 className='card-title l mb-16'>Información del usuario</h3>
          <div className='separador' style={{opacity: '10%'}}></div>
        </div>
        <div className='mt-16'>
          <div className='form-content'>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='username' className='field-label m'>
                  {DICCIONARIO.USERNAME}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='username'
                  placeholder={DICCIONARIO.USERNAME}
                  id='username'
                  value={formUser.username}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={20}
                />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    justifyContent: 'flex-end',
                    marginTop: '2%',
                  }}
                >
                  <p className='alert s' style={{maxWidth: '250px'}}>{formError.username}</p>
                  <div style={{width: 'auto', marginLeft: 'auto'}}>
                    <Tooltip title={formError.username2} placement='top' arrow>
                      <button
                        type='button'
                        style={{
                          color: '#13AD90',
                          textDecorationLine: 'underline',
                          backgroundColor: 'white',
                        }}
                        onClick={sugerencia}
                      >
                        Mostrar sugerencia
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className='label-input'>
                <label htmlFor='email' className='field-label m'>
                  {DICCIONARIO.EMAIL}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='type'
                  className='m text-field w-input'
                  name='email'
                  placeholder={DICCIONARIO.EMAIL}
                  id='email'
                  value={formUser.email}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={45}
                />
                {formError.email && <p className='alert s'>{formError.email}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='location' className='field-label m'>
                  {DICCIONARIO.DIRECCION}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='location'
                  placeholder={DICCIONARIO.DIRECCION}
                  id='location'
                  value={formUser.location}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={100}
                />
                {formError.location && <p className='alert s'>{formError.location}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='separador mt-16'></div>
      <div
        className='mt-16 w-100  button-actions'
        style={{display: 'flex', justifyContent: 'space-between'}}
      >
        <button
          type='button'
          className='m button transparent w-inline-block w-auto'
          onClick={cancelar}
        >
          <div>Anterior</div>
        </button>
        <button type='submit' className='m button w-inline-block w-auto' disabled={disabled}>
          <div>Siguiente</div>
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default CUStep11Usuario
